import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IpLocationService {

  constructor(private http: HttpClient) { }

  getUserCountry(): Observable<any> {
    return this.http.get('https://ipinfo.io/json');
  }
}